import React from 'react';
import { hasKpiPermission } from '../../utils/permissions';
import './KPILayout.css';

const KPILayout = ({ currentView, onNavigate, children, user }) => {
  const handleNav = (view) => (e) => {
    e.preventDefault();
    if (typeof onNavigate === 'function') {
      onNavigate(view);
    } else {
      window.dispatchEvent(new CustomEvent('navigate', { detail: view }));
    }
  };

  const isActive = (view) => currentView === view;

  return (
    <div className="kpi-layout">
      <aside className="kpi-sidebar">
        <nav className="kpi-sidebar-nav">
          <a
            href="#kpi"
            className={`kpi-sidebar-item ${isActive('kpi') ? 'active' : ''}`}
            onClick={handleNav('kpi')}
            title="DASHBOARD KPI"
          >
            <span className="kpi-sidebar-icon kpi-sidebar-icon-gauge">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 6v6l4 2" />
                <path d="M12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
              </svg>
            </span>
            <span className="kpi-sidebar-label">Strona główna KPI</span>
          </a>
          <a
            href="#kpi-ps"
            className={`kpi-sidebar-item ${isActive('kpi-ps') ? 'active' : ''}`}
            onClick={handleNav('kpi-ps')}
            title="PS"
          >
            <span className="kpi-sidebar-icon kpi-sidebar-icon-ps">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </span>
            <span className="kpi-sidebar-label">PS</span>
          </a>
          <a
            href="#kpi-pick"
            className={`kpi-sidebar-item ${isActive('kpi-pick') ? 'active' : ''}`}
            onClick={handleNav('kpi-pick')}
            title="PICK"
          >
            <span className="kpi-sidebar-icon kpi-sidebar-icon-pick">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 11l3 3L22 4" />
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
              </svg>
            </span>
            <span className="kpi-sidebar-label">PICK</span>
          </a>
          <a
            href="#kpi-transport"
            className={`kpi-sidebar-item ${isActive('kpi-transport') ? 'active' : ''}`}
            onClick={handleNav('kpi-transport')}
            title="TRANSPORT"
          >
            <span className="kpi-sidebar-icon kpi-sidebar-icon-transport">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="1" y="3" width="15" height="13" />
                <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                <circle cx="5.5" cy="18.5" r="2.5" />
                <circle cx="18.5" cy="18.5" r="2.5" />
              </svg>
            </span>
            <span className="kpi-sidebar-label">TRANSPORT</span>
          </a>
          <a
            href="#kpi-forklif"
            className={`kpi-sidebar-item ${isActive('kpi-forklif') ? 'active' : ''}`}
            onClick={handleNav('kpi-forklif')}
            title="OWW KPI"
          >
            <span className="kpi-sidebar-icon kpi-sidebar-icon-forklif">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                {/* Kabina / nadwozie */}
                <rect x="5" y="10" width="8" height="6" rx="0.5" />
                {/* Maszt pionowy */}
                <rect x="12" y="6" width="2" height="10" />
                {/* Widły – dwa zęby poziome */}
                <line x1="14" y1="8" x2="21" y2="8" />
                <line x1="14" y1="10" x2="21" y2="10" />
                <line x1="21" y1="8" x2="21" y2="10" />
                {/* Koła */}
                <circle cx="6" cy="18" r="2" />
                <circle cx="12" cy="18" r="2" />
              </svg>
            </span>
            <span className="kpi-sidebar-label">OWW KPI</span>
          </a>
          <a
            href="#kpi-przyjecie"
            className={`kpi-sidebar-item ${isActive('kpi-przyjecie') ? 'active' : ''}`}
            onClick={handleNav('kpi-przyjecie')}
            title="PRZYJĘCIE"
          >
            <span className="kpi-sidebar-icon kpi-sidebar-icon-przyjecie">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                <line x1="12" y1="22.08" x2="12" y2="12" />
              </svg>
            </span>
            <span className="kpi-sidebar-label">PRZYJĘCIE</span>
          </a>
          <a
            href="#kpi-inspekt"
            className={`kpi-sidebar-item ${isActive('kpi-inspekt') ? 'active' : ''}`}
            onClick={handleNav('kpi-inspekt')}
            title="INSPEKT"
          >
            <span className="kpi-sidebar-icon kpi-sidebar-icon-inspekt">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
                <rect x="9" y="3" width="6" height="4" rx="1" />
                <path d="M9 12l2 2 4-4" />
              </svg>
            </span>
            <span className="kpi-sidebar-label">INSPEKT</span>
          </a>
          {hasKpiPermission(user, 'kpiPodsumowanieView') && (
          <a
            href="#kpi-podsumowanie"
            className={`kpi-sidebar-item ${isActive('kpi-podsumowanie') ? 'active' : ''}`}
            onClick={handleNav('kpi-podsumowanie')}
            title="PODSUMOWANIE"
          >
            <span className="kpi-sidebar-icon kpi-sidebar-icon-podsumowanie">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="20" x2="12" y2="10" />
                <line x1="18" y1="20" x2="18" y2="4" />
                <line x1="6" y1="20" x2="6" y2="16" />
              </svg>
            </span>
            <span className="kpi-sidebar-label">Podsumowanie</span>
          </a>
          )}
          {hasKpiPermission(user, 'uzupelnijRaportView') && (
          <a
            href="#kpi-raport"
            className={`kpi-sidebar-item ${isActive('kpi-raport') ? 'active' : ''}`}
            onClick={handleNav('kpi-raport')}
            title="UZUPEŁNIJ RAPORT"
          >
            <span className="kpi-sidebar-icon kpi-sidebar-icon-sheet kpi-sidebar-icon-raport">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <line x1="10" y1="9" x2="8" y2="9" />
              </svg>
            </span>
            <span className="kpi-sidebar-label">Uzupełnij raport</span>
          </a>
          )}
          {user?.role === 'owner' && (
          <a
            href="#kpi-widget"
            className={`kpi-sidebar-item ${isActive('kpi-widget') ? 'active' : ''}`}
            onClick={handleNav('kpi-widget')}
            title="WIDGET"
          >
            <span className="kpi-sidebar-icon kpi-sidebar-icon-widget">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="7" height="7" rx="1" />
                <rect x="14" y="3" width="7" height="7" rx="1" />
                <rect x="3" y="14" width="7" height="7" rx="1" />
                <rect x="14" y="14" width="7" height="7" rx="1" />
              </svg>
            </span>
            <span className="kpi-sidebar-label">Widget</span>
          </a>
          )}
        </nav>
      </aside>
      <main className={`kpi-main ${currentView === 'kpi-raport' ? 'kpi-main-raport' : ''}`}>
        {children}
      </main>
    </div>
  );
};

export default KPILayout;
